import * as React from 'react';
import S from './MobileNavigation.styles';
const MobileNavigation = ({ activePage = '', isOpen, links }) => {
    const [stack, setStack] = React.useState([]);
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (isOpen) {
            setStack([]);
        }
    }, [isOpen]);
    // Render top level navigation...
    if (stack.length === 0) {
        return renderDefault();
    }
    // ...or current level.
    return renderLevel(stack[stack.length - 1]);
    /**
     * Render the top-level layout.
     * @returns
     */
    function renderDefault() {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "aria-hidden": !isOpen, "aria-label": "Main Navigation" },
            React.createElement(S.ListArea, null,
                React.createElement(S.List, null, links.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.url, tabIndex: isOpen ? 0 : -1, target: item.target, "data-active-page": activePage === item.id, onClick: (event) => {
                            if (item.children && item.children.length > 0) {
                                event.preventDefault();
                                push(item);
                            }
                        } },
                        React.createElement(S.Text, null, item.text),
                        !!item.children?.length && React.createElement(S.Arrow, null)))))))));
    }
    /**
     * Render the layout for the current active item (last in stack).
     * @returns
     */
    function renderLevel(activeItem) {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "data-has-grandchildren": activeItem.children && activeItem.children?.filter(item => item.children).length > 0 ? true : false },
            React.createElement(S.Header, null,
                React.createElement(S.Back, { onClick: (event) => {
                        event.preventDefault();
                        pop();
                    } },
                    React.createElement(S.BackSvg, null),
                    React.createElement("span", null, activeItem.text)),
                activeItem.intro && React.createElement(S.IntroContent, null, activeItem.intro)),
            React.createElement(S.List, null,
                React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: activeItem.url, target: activeItem.target },
                        React.createElement(S.Text, null,
                            React.createElement("span", null, activeItem.text)))),
                activeItem.children &&
                    activeItem.children.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(S.Link, { href: item.url, target: item.target, "data-active-page": activePage === item.id, onClick: (event) => {
                                if (item.children && item.children.length > 0) {
                                    event.preventDefault();
                                    item && push(item);
                                }
                            } },
                            React.createElement(S.Text, null,
                                React.createElement("span", null, item.text)),
                            !!item.children?.length && React.createElement(S.Arrow, null))))))));
    }
    /**
     * Push navigation item to stack.
     * @param item
     */
    function push(item) {
        const newStack = [...stack, item];
        setStack(newStack);
    }
    /**
     * Pop last item from stack.
     * @param item
     */
    function pop() {
        const newStack = stack.slice(0, stack.length - 1);
        setStack(newStack);
    }
};
export default MobileNavigation;
